import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Layout from '@/components/Layout'

Vue.use(Router)

const originalPush = Router.prototype.push
   Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
//组件的异步加载
const Home = resolve => {
  require.ensure([], () => resolve(require('@/Views/Home/Index.vue')), 'Home')
}
const Procurement = resolve => {
  require.ensure([], () => resolve(require('@/Views/Procurement/Index.vue')), 'Procurement')
}
const Sales = resolve => {
  require.ensure([], () => resolve(require('@/Views/Sales/Index.vue')), 'Sales')
}
const Inventory = resolve => {
  require.ensure([], () => resolve(require('@/Views/Inventory/Index.vue')), 'Inventory')
}
const Themaster = resolve => {
  require.ensure([], () => resolve(require('@/Views/Themaster/Index.vue')), 'Themaster')
}
const Batch = resolve => {
  require.ensure([], () => resolve(require('@/Views/Batch/Index.vue')), 'Batch')
}
const ReportDownload = resolve => {
  require.ensure([], () => resolve(require('@/Views/Batch/ReportDownload.vue')), 'ReportDownload')
}
const StockReportDownload = resolve => {
  require.ensure([], () => resolve(require('@/Views/Batch/StockReportDownload.vue')), 'StockReportDownload')
}
const SaleReportDownload = resolve => {
  require.ensure([], () => resolve(require('@/Views/Batch/SaleReportDownload.vue')), 'SaleReportDownload')
}
const SaleRollReport = resolve => {
  require.ensure([], () => resolve(require('@/Views/Batch/SaleRollReport.vue')), 'SaleRollReport')
}
const Customerservice = resolve => {
  require.ensure([], () => resolve(require('@/Views/Customerservice/Index.vue')), 'Customerservice')
}
const Operatingreports = resolve => {
  require.ensure([], () => resolve(require('@/Views/Operatingreports/Index.vue')), 'Operatingreports')
}
const Onlinetraining = resolve => {
  require.ensure([], () => resolve(require('@/Views/Onlinetraining/Index.vue')), 'Onlinetraining')
}
const User = resolve => {
  require.ensure([], () => resolve(require('@/Views/User/User.vue')), 'User')
}
const UserStore = resolve => {
  require.ensure([], () => resolve(require('@/Views/User/UserStore.vue')), 'UserStore')
}
const ApiReqLog = resolve => {
  require.ensure([], () => resolve(require('@/Views/ApiLog/ApiReqLog.vue')), 'ApiReqLog')
}
const SalesRecord = resolve => {
  require.ensure([], () => resolve(require('@/Views/Customerservice/SalesRecord.vue')), 'SalesRecord')
}
const StoreUser = resolve => {
  require.ensure([], () => resolve(require('@/Views/User/StoreUser.vue')), 'StoreUser')
}

const InbounManage = resolve => {
  require.ensure([], () => resolve(require('@/Views/Warehouse/InbounManage.vue')), 'InbounManage')
}
const OutboundManage = resolve => {
  require.ensure([], () => resolve(require('@/Views/Warehouse/OutboundManage.vue')), 'OutboundManage')
}
const InbounDownload = resolve => {
  require.ensure([], () => resolve(require('@/Views/Warehouse/InbounDownload.vue')), 'InbounDownload')
}
const OutboundDownload = resolve => {
  require.ensure([], () => resolve(require('@/Views/Warehouse/OutboundDownload.vue')), 'OutboundDownload')
}
const StoreTransferReceiving = resolve => {
  require.ensure([], () => resolve(require('@/Views/Customerservice/StoreTransferReceiving.vue')), 'StoreTransferReceiving')
}
const WarehouseWarehouseReceiving = resolve => {
  require.ensure([], () => resolve(require('@/Views/Customerservice/WarehouseWarehouseReceiving.vue')), 'WarehouseWarehouseReceiving')
}

const Error = resolve => {
  require.ensure([], () => resolve(require('@/Views/Error/Error404.vue')), 'Error')
}
const router= new Router({
  mode:'hash',
  // base: __dirname,
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Layout',
      name: 'Layout',
      redirect: '/Layout',
      component: Layout ,
      meta: { requiresAuth: true },
      children: [
        {
          path: '/Home',
          component: Home,
          routerName: 'Home',
          name: '首页',
          meta: { requiresAuth: true }
        },
        {
          path: '/User',
          routerName: 'User',
          name: '用户管理',
          component: User,
          meta: { requiresAuth: true }
        },
        {
          path: '/UserStore',
          routerName: 'UserStore',
          name: '角色管理',
          component: UserStore,
          meta: { requiresAuth: true }
        },
        {
          path: '/StoreUser',
          routerName: 'StoreUser',
          name: '店铺管理',
          component: StoreUser,
          meta: { requiresAuth: true }
        },
        {
          path: '/ApiReqLog',
          routerName: 'ApiReqLog',
          name: 'API请求日志',
          component: ApiReqLog,
          meta: { requiresAuth: true }
        },
        {
          path: '/Procurement',
          routerName: 'Procurement',
          name: '采购管理',
          component: Procurement,
          meta: { requiresAuth: true }
        },
        {
          path: '/Sales',
          routerName: 'Sales',
          name: '销售管理',
          component: Sales,
          meta: { requiresAuth: true }
        },
        {
          path: '/Inventory',
          routerName: 'Inventory',
          name: '库存管理',
          component: Inventory,
          meta: { requiresAuth: true }
        },
        {
          path: '/Themaster',
          routerName: 'Themaster',
          name: '主数据管理',
          component: Themaster,
          meta: { requiresAuth: true }
        },
        {
          path: '/Batch',
          routerName: 'Batch',
          name: '批量管理',
          component: Batch,
          meta: { requiresAuth: true }
        },
        {
          path: '/ReportDownload',
          routerName: 'ReportDownload',
          name: '下载',
          component: ReportDownload,
          meta: { requiresAuth: true }
        },
        {
          path: '/StockReportDownload',
          routerName: 'StockReportDownload',
          name: '库存报表下载',
          component: StockReportDownload,
          meta: { requiresAuth: true }
        },
        {
          path: '/SaleReportDownload',
          routerName: 'SaleReportDownload',
          name: '销售下载',
          component: SaleReportDownload,
          meta: { requiresAuth: true }
        },
        {
          path: '/SaleRollReport',
          routerName: 'SaleRollReport',
          name: '滚动销售报表下载',
          component: SaleRollReport,
          meta: { requiresAuth: true }
        },
        {
          path: '/Customerservice',
          routerName: 'Customerservice',
          name: '客户服务',
          component: Customerservice,
          meta: { requiresAuth: true }
        },
        {
          path: '/SalesRecord',
          routerName: 'SalesRecord',
          name: 'cc销售记录查询',
          component: SalesRecord,
          meta: { requiresAuth: true }
        },
        {
          path: '/Operatingreports',
          routerName: 'Operatingreports',
          name: '运营报表',
          component: Operatingreports,
          meta: { requiresAuth: true }
        },
        {
          path: '/Onlinetraining',
          routerName: 'Onlinetraining',
          name: '在线培训',
          component: Onlinetraining,
          meta: { requiresAuth: true }
        },

        {
          path: '/InbounManage',
          routerName: 'InbounManage',
          name: '入库管理',
          component: InbounManage,
          meta: { requiresAuth: true }
        },
        {
          path: '/OutboundManage',
          routerName: 'OutboundManage',
          name: '出库管理',
          component: OutboundManage,
          meta: { requiresAuth: true }
        },
        {
          path: '/InbounDownload',
          routerName: 'InbounDownload',
          name: '仓库入库下载',
          component: InbounDownload,
          meta: { requiresAuth: true }
        },
        {
          path: '/OutboundDownload',
          routerName: 'OutboundDownload',
          name: '仓库出库下载',
          component: OutboundDownload,
          meta: { requiresAuth: true }
        },
      
        {
          path: '/StoreTransferReceiving',
          routerName: 'StoreTransferReceiving',
          name: '店铺转货收货',
          component: StoreTransferReceiving,
          meta: { requiresAuth: true }
        },
        {
          path: '/WarehouseWarehouseReceiving',
          routerName: 'WarehouseWarehouseReceiving',
          name: '仓库出库收货',
          component: WarehouseWarehouseReceiving,
          meta: { requiresAuth: true }
        },
      ]
    },
    {
      path: '*',
      routerName: 'Error404',
      name: 'Error404',
      component: Error,
    },
  ]
})
// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  // 如果用户访问的登录页，直接放行
  if (to.path === '/Login') return next()
  // 从sessionStorage中获取到保存的token值
  const tokenStr = window.sessionStorage.getItem('token')

  // 没有token 强制跳转到登录页
  if (!tokenStr) return next('/Login')
  next()
})



export default router;


 






// WEBPACK FOOTER //
// ./src/router/index.js